import { Padding, PaddingObject } from "../model/Layout";

export const getPaddingValue = (padding: Padding, side: keyof PaddingObject) =>
  typeof padding === "number" ? padding : padding[side];
